module.exports = __webpack_public_path__ + "img/Boarded 3.12685478.svg";